// import Api from './Api'
import axios from 'axios'

export default {
    get() {
        return axios.get(`https://server-associados.sbn.org.br/api/navbar`);
    }
}